/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_DeletedInputs */

const cs_property_ai_deleted = /** @type {(inputs: Property_Ai_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Návrh smazán`)
};

const en_property_ai_deleted = /** @type {(inputs: Property_Ai_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft deleted`)
};

/**
* | output |
* | --- |
* | "Draft deleted" |
*
* @param {Property_Ai_DeletedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_deleted = /** @type {((inputs?: Property_Ai_DeletedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_DeletedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_deleted(inputs)
	return cs_property_ai_deleted(inputs)
});